
import Button from "react-bootstrap/Button";


import { ISelectOption } from "../../interfaces/interfaces";
import {
  IProvisioningSettings, ProvisioningSettingKeyType, ProvisioningSettingLDAPVersion,
  ProvisioningSettingLocalTimeZone,
  ProvisioningSettingPhoneLanguage, ProvisioningSettingsDesktopAppExtensionsToShow, ProvisioningSettingTransportMethod
} from "../../interfaces/provisioning";
import ReviewCollapse from "../../pages/Service/ReviewCollapse";
import VipProvisioningCustomFields from "../VipProvisioningCustomFields";
import VipProvisioningYealink from "../VipProvisioningYealinkFirmwares";
import VipProvisioningFieldMui from "../VipProvisioningFieldMui";
import { memo, useState } from "react";
import Loading from "../loading";
import VipProvisioningYealinkFirmwares from "../VipProvisioningYealinkFirmwares";
import VipProvisioningYealinkWallpapers from "../VipProvisioningYealinkWallpapers";
import React from "react";



export interface IFormProvisioningProp {
  resellerMode: boolean;
  showYeaLinkFirmware: boolean;
  data: any;
  submitFunction: (data: IProvisioningSettings) => void;
  updateFieldOverride?: (fieldName: string, data: any) => void;
}




const enumToOptions = function (
  keys: string[],
  values: string[]
): ISelectOption[] {
  const options: ISelectOption[] = [];
  for (var i = 0; i < keys.length; i++) {
    let selectOption = {
      label: keys[i],
      value: values[i],
    };
    options.push(selectOption);
  }
  return options;
};




const transportSelectOptions = enumToOptions(
  Object.keys(ProvisioningSettingTransportMethod),
  Object.values(ProvisioningSettingTransportMethod)
);
const ldapVersionOptions = enumToOptions(
  Object.keys(ProvisioningSettingLDAPVersion),
  Object.values(ProvisioningSettingLDAPVersion)
);
const localTimeZoneOptions = enumToOptions(
  Object.keys(ProvisioningSettingLocalTimeZone),
  Object.values(ProvisioningSettingLocalTimeZone)
);
const phoneLanguageOptions = enumToOptions(
  Object.keys(ProvisioningSettingPhoneLanguage),
  Object.values(ProvisioningSettingPhoneLanguage)
);
const programmableKey3TypeOptions = enumToOptions(Object.keys(ProvisioningSettingKeyType),Object.values(ProvisioningSettingKeyType))
const desktopAppExtensionsToShowOptions = enumToOptions(Object.keys(ProvisioningSettingsDesktopAppExtensionsToShow), Object.values(ProvisioningSettingsDesktopAppExtensionsToShow))
const lineKeys1:number[] = []
const lineKeys2:number[] = []
const lineKeys3:number[] = []
const lineKeys4:number[] = []
const lineKeys5:number[] = []
for(let i=1;i<=20;i++){
  lineKeys1.push(i)
  lineKeys2.push(i+20)
  lineKeys3.push(i+40)
  lineKeys4.push(i+60)
  lineKeys5.push(i+80)
}

const expansionModule1Keys:number[] = []
for(let i=1;i<=78;i++){
  expansionModule1Keys.push(i)
}

const FormProvisioning = ({ resellerMode, showYeaLinkFirmware, data, submitFunction, updateFieldOverride }: IFormProvisioningProp) => {
  const [isSaving, setIsSaving] = useState(false)
  const [state, setState] = useState<any>(() => data)


  const handleSubmit = (event: React.FormEvent): void => {
    event.preventDefault();
    setIsSaving(true)
    submitFunction(state);
  };
  const updateField = (fieldName: any, payload: any) => {
    //console.log('updateField',fieldName,payload)
    setState((prev: any) => {
     // console.log("fp-updateField-", fieldName, payload);
      const stateC = { ...prev };

      stateC[fieldName] = payload;
      return stateC;
    });
    if (updateFieldOverride !== undefined) {
      updateFieldOverride(fieldName, payload);
    }

  };


  return <>
    <VipProvisioningFieldMui

      updateField={updateField}
      data={state.yealinkTemplateVersion}
      dataField="yealinkTemplateVersion"
      title="Yealink Template Version"
      type="string"
    />

    <ReviewCollapse header="Line Keys 1 - 20" initalOpen={false} content={<>
      {lineKeys1.map((val, valIndex) => {

        const line = state[`linekey_${val}_line`]

        return <div key={valIndex}>
          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_type`]}
            dataField={`linekey_${val}_type`}
            title={`Line Key ${val} Type`}
            selectOptions={[{ value: "0", label: "Disabled" },{ value: "16", label: "BLF" },{value:'5',label:'DND'},{value:'11',label:'DTMF'},{ value: "15", label: "Line" },{value:"13",label:"Speed Dial"},{value:"3",label:'Transfer'}]}
            type="select"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={line}
            dataField={`linekey_${val}_line`}
            title={`Line Key ${val} Line`}
            type="number"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_label`]}
            dataField={`linekey_${val}_label`}
            title={`Line Key ${val} Label`}
            type="string"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_value`]}
            dataField={`linekey_${val}_value`}
            title={`Line Key ${val} Value`}
            type="string"
          />

          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_extension`]}
            dataField={`linekey_${val}_extension`}
            title={`Line Key ${val} Extension`}
            type="string"
          />
          <hr className="mb-3" />
        </div>
      })}
    </>} />

    <ReviewCollapse header="Line Keys 21 - 40" initalOpen={false} content={<>
      {lineKeys2.map((val, valIndex) => {

        const line = state[`linekey_${val}_line`]

        return <div key={valIndex}>
          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_type`]}
            dataField={`linekey_${val}_type`}
            title={`Line Key ${val} Type`}
            selectOptions={[{ value: "0", label: "Disabled" },{ value: "16", label: "BLF" },{value:'5',label:'DND'},{value:'11',label:'DTMF'},{ value: "15", label: "Line" },{value:"13",label:"Speed Dial"},{value:"3",label:'Transfer'}]}
            type="select"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={line}
            dataField={`linekey_${val}_line`}
            title={`Line Key ${val} Line`}
            type="number"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_label`]}
            dataField={`linekey_${val}_label`}
            title={`Line Key ${val} Label`}
            type="string"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_value`]}
            dataField={`linekey_${val}_value`}
            title={`Line Key ${val} Value`}
            type="string"
          />

          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_extension`]}
            dataField={`linekey_${val}_extension`}
            title={`Line Key ${val} Extension`}
            type="string"
          />
          <hr className="mb-3" />
        </div>
      })}
    </>} />

    <ReviewCollapse header="Line Keys 41 - 60" initalOpen={false} content={<>
      {lineKeys3.map((val, valIndex) => {

        const line = state[`linekey_${val}_line`]

        return <div key={valIndex}>
          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_type`]}
            dataField={`linekey_${val}_type`}
            title={`Line Key ${val} Type`}
            selectOptions={[{ value: "0", label: "Disabled" },{ value: "16", label: "BLF" },{value:'5',label:'DND'},{value:'11',label:'DTMF'},{ value: "15", label: "Line" },{value:"13",label:"Speed Dial"},{value:"3",label:'Transfer'}]}
            type="select"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={line}
            dataField={`linekey_${val}_line`}
            title={`Line Key ${val} Line`}
            type="number"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_label`]}
            dataField={`linekey_${val}_label`}
            title={`Line Key ${val} Label`}
            type="string"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_value`]}
            dataField={`linekey_${val}_value`}
            title={`Line Key ${val} Value`}
            type="string"
          />

          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_extension`]}
            dataField={`linekey_${val}_extension`}
            title={`Line Key ${val} Extension`}
            type="string"
          />
          <hr className="mb-3" />
        </div>
      })}
    </>} />

    <ReviewCollapse header="Line Keys 61 - 80" initalOpen={false} content={<>
      {lineKeys4.map((val, valIndex) => {

        const line = state[`linekey_${val}_line`]

        return <div key={valIndex}>
          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_type`]}
            dataField={`linekey_${val}_type`}
            title={`Line Key ${val} Type`}
            selectOptions={[{ value: "0", label: "Disabled" },{ value: "16", label: "BLF" },{value:'5',label:'DND'},{value:'11',label:'DTMF'},{ value: "15", label: "Line" },{value:"13",label:"Speed Dial"},{value:"3",label:'Transfer'}]}
            type="select"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={line}
            dataField={`linekey_${val}_line`}
            title={`Line Key ${val} Line`}
            type="number"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_label`]}
            dataField={`linekey_${val}_label`}
            title={`Line Key ${val} Label`}
            type="string"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_value`]}
            dataField={`linekey_${val}_value`}
            title={`Line Key ${val} Value`}
            type="string"
          />

          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_extension`]}
            dataField={`linekey_${val}_extension`}
            title={`Line Key ${val} Extension`}
            type="string"
          />
          <hr className="mb-3" />
        </div>
      })}
    </>} />

    <ReviewCollapse header="Line Keys 81 - 100" initalOpen={false} content={<>
      {lineKeys5.map((val, valIndex) => {

        const line = state[`linekey_${val}_line`]

        return <div key={valIndex}>
          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_type`]}
            dataField={`linekey_${val}_type`}
            title={`Line Key ${val} Type`}
            selectOptions={[{ value: "0", label: "Disabled" },{ value: "16", label: "BLF" },{value:'5',label:'DND'},{value:'11',label:'DTMF'},{ value: "15", label: "Line" },{value:"13",label:"Speed Dial"},{value:"3",label:'Transfer'}]}
            type="select"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={line}
            dataField={`linekey_${val}_line`}
            title={`Line Key ${val} Line`}
            type="number"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_label`]}
            dataField={`linekey_${val}_label`}
            title={`Line Key ${val} Label`}
            type="string"
          />
          <VipProvisioningFieldMui

            updateField={updateField}
            data={state[`linekey_${val}_value`]}
            dataField={`linekey_${val}_value`}
            title={`Line Key ${val} Value`}
            type="string"
          />

          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`linekey_${val}_extension`]}
            dataField={`linekey_${val}_extension`}
            title={`Line Key ${val} Extension`}
            type="string"
          />
          <hr className="mb-3" />
        </div>
      })}
    </>} />

    <ReviewCollapse header="Account 1" initalOpen={false} content={<>
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.transportMethod}
        dataField="transportMethod"
        title="Account 1 Transport"
        type="select"
        selectOptions={transportSelectOptions}
      />
      <VipProvisioningFieldMui
        updateField={updateField}
        data={state.srtp}
        dataField="srtp"
        title="Account 1 SRTP"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.account1MissedCallLog}
        dataField="account1MissedCallLog"
        title="Account 1 Missed Call Log"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.useCallerIdAsLabel}
        dataField="useCallerIdAsLabel"
        title="Use caller ID as phone label?"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.account1Label}
        dataField="account1Label"
        title="Account 1 Label"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.account1DisplayName}
        dataField="account1DisplayName"
        title="Account 1 Display Name"
        type="string"
      />

    </>} />

    <ReviewCollapse header="Account 2" initalOpen={false} content={<>
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.account2TransportMethod}
        dataField="account2TransportMethod"
        title="Account 2 Transport"
        type="select"
        selectOptions={transportSelectOptions}
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.account2Srtp}
        dataField="account2Srtp"
        title="Account 2 SRTP"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.account2MissedCallLog}
        dataField="account2MissedCallLog"
        title="Account 2 Missed Call Log"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.account2Label}
        dataField="account2Label"
        title="Account 2 Label"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.account2DisplayName}
        dataField="account2DisplayName"
        title="Account 2 Display Name"
        type="string"
      />
    </>} />

    <ReviewCollapse header="LDAP" initalOpen={false} content={<>
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapEnable}
        dataField="ldapEnable"
        title="Enable LDAP"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapNameFilter}
        dataField="ldapNameFilter"
        title="LDAP Name Filter"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapNumberFilter}
        dataField="ldapNumberFilter"
        title="LDAP Number Filter"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapHost}
        dataField="ldapHost"
        title="LDAP Host"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapPort}
        dataField="ldapPort"
        title="LDAP Port"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapBase}
        dataField="ldapBase"
        title="LDAP Base"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapUser}
        dataField="ldapUser"
        title="LDAP User"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapPassword}
        dataField="ldapPassword"
        title="LDAP Password"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapMaxHits}
        dataField="ldapMaxHits"
        title="LDAP Max Hits"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapNameAttributes}
        dataField="ldapNameAttributes"
        title="LDAP Name Attributes"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapNumberAttributes}
        dataField="ldapNumberAttributes"
        title="LDAP Number Attributes"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapDisplayName}
        dataField="ldapDisplayName"
        title="LDAP Display Name"
        type="string"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapVersion}
        dataField="ldapVersion"
        title="LDAP Version"
        type="select"
        selectOptions={ldapVersionOptions}
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapCallInLookup}
        dataField="ldapCallInLookup"
        title="LDAP Look Up Incoming Calls"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.ldapSort}
        dataField="ldapSort"
        title="LDAP Alphabetical Sort"
        type="boolean"
      />
    </>} />


    <hr className="mb-3" />
    <VipProvisioningFieldMui
      updateField={updateField}
      data={state.networkDhcpHostName}
      dataField="networkDhcpHostName"
      title="DHCP Host Name"
      type="string"
    />
    <hr className="mb-3" />

    <VipProvisioningFieldMui
      updateField={updateField}
      data={state.programmablekey3Type}
      dataField="programmablekey3Type"
      title="Programmable Key 3 Type"
      type="select"
      selectOptions={programmableKey3TypeOptions}
    />

    <VipProvisioningFieldMui
      updateField={updateField}
      data={state.localTimeTimeZone}
      dataField="localTimeTimeZone"
      title="Time Zone"
      type="select"
      selectOptions={localTimeZoneOptions}
    />

    <VipProvisioningFieldMui
      updateField={updateField}
      data={state.customStatusesJson}
      dataField="customStatusesJson"
      title="Custom Statuses"
      type="CustomStatuses"
    />

    <VipProvisioningFieldMui
      updateField={updateField}
      data={state.phoneLanguage}
      dataField="phoneLanguage"
      title="Phone Language"
      type="select"
      selectOptions={phoneLanguageOptions}
    />

    <VipProvisioningFieldMui
      updateField={updateField}
      data={state.featuresSpeakerModeEnable}
      dataField="featuresSpeakerModeEnable"
      title="Speaker Mode Enabled?"
      type="boolean"
    />

    <VipProvisioningFieldMui
      updateField={updateField}
      data={state.wuiHttpEnable}
      dataField="wuiHttpEnable"
      title="HTTP Admin Panel Enabled?"
      type="boolean"
    />
    <VipProvisioningFieldMui

      updateField={updateField}
      data={state.wuiHttpsEnable}
      dataField="wuiHttpsEnable"
      title="HTTPS Admin Panel Enabled?"
      type="boolean"
    />
    <VipProvisioningFieldMui

      updateField={updateField}
      data={state.phoneSettingMissedCallPowerLedFlashEnable}
      dataField="phoneSettingMissedCallPowerLedFlashEnable"
      title="Power Light Flash After Missed Call?"
      type="boolean"
    />
    <VipProvisioningFieldMui

      updateField={updateField}
      data={state.featuresVoiceMailPopupEnable}
      dataField="featuresVoiceMailPopupEnable"
      title="Voice Mail Pop Up Notifications?"
      type="boolean"
    />
    
    <VipProvisioningFieldMui
      updateField={updateField}
      data={state.staticSecurityAdminPassword}
      dataField="staticSecurityAdminPassword"
      title="Admin Panel Password"
      type="string"
    />
    
    <VipProvisioningFieldMui
      updateField={updateField}
      data={state.staticSecurityUserPassword}
      dataField="staticSecurityUserPassword"
      title="User Panel Password"
      type="string"
    />
    
    <VipProvisioningFieldMui

      updateField={updateField}
      data={state.enabledDirectories}
      dataField="enabledDirectories"
      title="Enabled Directories"
      type="checkBoxList"
      payload={[
        { id: "LDAP", name: "LDAP" },
        { id: "History", name: "History" },
        { id: "Remote Phone Book", name: "Remote Phone Book" },
        { id: "Blacklist", name: "Blacklist" },
        { id: "Local Directory", name: "Local Directory" },
      ]}
    />


    <ReviewCollapse header="Desktop App" initalOpen={false} content={<>
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.desktopAppAutomaticUpdatesDisabled}
        dataField="desktopAppAutomaticUpdatesDisabled"
        title="Desktop App Automatic Updates Disabled"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.desktopAppAutomaticAnswerDisabled}
        dataField="desktopAppAutomaticAnswerDisabled"
        title="Desktop App Automatic Answer Disabled"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.desktopAppCloseWindowDisabled}
        dataField="desktopAppCloseWindowDisabled"
        title="Desktop App Close Window Disabled"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.desktopAppCallFileOnAnswer}
        dataField="desktopAppCallFileOnAnswer"
        title="Desktop App Generate Call File On Answer"
        type="boolean"
      />
      <VipProvisioningFieldMui

        updateField={updateField}
        data={state.desktopAppExtensionsToShow}
        dataField="desktopAppExtensionsToShow"
        title="Desktop App Extensions To Show"
        type="select"
        selectOptions={desktopAppExtensionsToShowOptions}
      />
    </>} />

    {resellerMode && (
      <>
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.featuresShowActionUriOption}
          dataField="featuresShowActionUriOption"
          title="Show Action Uri Option"
          type="boolean"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.featuresActionUriLimitIp}
          dataField="featuresActionUriLimitIp"
          title="Action Uri Allow IP List"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlSetupCompleted}
          dataField="actionUrlSetupCompleted"
          title="Action URL Setup Complete"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlRegistered}
          dataField="actionUrlRegistered"
          title="Action URL Registered"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlUnregistered}
          dataField="actionUrlUnregistered"
          title="Action URL Unregistered"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlRegisterFailed}
          dataField="actionUrlRegisterFailed"
          title="Action URL Register Failed"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlOffHook}
          dataField="actionUrlOffHook"
          title="Action URL Off Hook"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlOnHook}
          dataField="actionUrlOnHook"
          title="Action URL On Hook"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlIncomingCall}
          dataField="actionUrlIncomingCall"
          title="Action URL Incoming Call"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlOutgoingCall}
          dataField="actionUrlOutgoingCall"
          title="Action URL Outgoing Call"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlCallEstablished}
          dataField="actionUrlCallEstablished"
          title="Action URL Call Established"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlDndOn}
          dataField="actionUrlDndOn"
          title="Action URL DND On"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlDndOff}
          dataField="actionUrlDndOff"
          title="Action URL DND Off"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlAlwaysFwdOn}
          dataField="actionUrlAlwaysFwdOn"
          title="Action URL Always Forward On"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlAlwaysFwdOff}
          dataField="actionUrlAlwaysFwdOff"
          title="Action URL Always Forward Off"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlBusyFwdOn}
          dataField="actionUrlBusyFwdOn"
          title="Action URL Busy Forward On"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlBusyFwdOff}
          dataField="actionUrlBusyFwdOff"
          title="Action URL Busy Forward Off"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlNoAnswerFwdOn}
          dataField="actionUrlNoAnswerFwdOn"
          title="Action URL No Answer Forward On"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlNoAnswerFwdOff}
          dataField="actionUrlNoAnswerFwdOff"
          title="Action URL No Answer Forward Off"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlTransferCall}
          dataField="actionUrlTransferCall"
          title="Action URL Transfer Call"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlBlindTransferCall}
          dataField="actionUrlBlindTransferCall"
          title="Action URL Blind Transfer Call"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlAttendedTransferCall}
          dataField="actionUrlAttendedTransferCall"
          title="Action URL Attended Transfer Call"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlHold}
          dataField="actionUrlHold"
          title="Action URL Hold"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlUnhold}
          dataField="actionUrlUnhold"
          title="Action URL Unhold"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlHeld}
          dataField="actionUrlHeld"
          title="Action URL Held"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlUnheld}
          dataField="actionUrlUnheld"
          title="Action URL Unheld"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlMute}
          dataField="actionUrlMute"
          title="Action URL Mute"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlUnmute}
          dataField="actionUrlUnmute"
          title="Action URL Unmute"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlMissedCall}
          dataField="actionUrlMissedCall"
          title="Action URL Missed Call"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlCallTerminated}
          dataField="actionUrlCallTerminated"
          title="Action URL Call Terminated"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlBusyToIdle}
          dataField="actionUrlBusyToIdle"
          title="Action URL Busy To Idle"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlIdleToBusy}
          dataField="actionUrlIdleToBusy"
          title="Action URL Idle To Busy"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlIpChange}
          dataField="actionUrlIpChange"
          title="Action URL IP Change"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlForwardIncomingCall}
          dataField="actionUrlForwardIncomingCall"
          title="Action URL Forward Incoming Call"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlRejectIncomingCall}
          dataField="actionUrlRejectIncomingCall"
          title="Action URL Reject Incoming Call"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlAnswerNewIncomingCall}
          dataField="actionUrlAnswerNewIncomingCall"
          title="Action URL Answer New Incoming Call"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlTransferFinished}
          dataField="actionUrlTransferFinished"
          title="Action URL Transfer Finished"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlTransferFailed}
          dataField="actionUrlTransferFailed"
          title="Action URL Transfer Failed"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlSetupAutopFinish}
          dataField="actionUrlSetupAutopFinish"
          title="Action URL Setup Auto Provision Finish"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlCallWaitingOn}
          dataField="actionUrlCallWaitingOn"
          title="Action URL Call Waiting On"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlCallWaitingOff}
          dataField="actionUrlCallWaitingOff"
          title="Action URL Call Waiting Off"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlHeadset}
          dataField="actionUrlHeadset"
          title="Action URL Headset"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlHandfree}
          dataField="actionUrlHandfree"
          title="Action URL Hands Free"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlCancelCallout}
          dataField="actionUrlCancelCallout"
          title="Action URL Cancel Callout"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlRemoteBusy}
          dataField="actionUrlRemoteBusy"
          title="Action URL Remote Busy"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlCallRemoteCanceled}
          dataField="actionUrlCallRemoteCanceled"
          title="Action URL Call Remove Cancelled"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlPeripheralInformation}
          dataField="actionUrlPeripheralInformation"
          title="Action URL Peripheral Infomation"
          type="string"
        />
        <VipProvisioningFieldMui

          updateField={updateField}
          data={state.actionUrlVpnIp}
          dataField="actionUrlVpnIp"
          title="Action URL VPN IP"
          type="string"
        />
      </>
    )}

    <ReviewCollapse header="Custom Fields" initalOpen={false} content={<>
      <VipProvisioningCustomFields
        value={data.customFields}
        updateField={updateField}
      />
    </>} />
    {[1,2,3].map((moduleIndex)=>{
      return <ReviewCollapse header={"Yealink Expansion Module "+moduleIndex} initalOpen={false} content={<>
      {expansionModule1Keys.map((val, valIndex) => {

        const line = state[`expansion_module_${moduleIndex}_key_${val}_line`]

        return <div key={valIndex}>
          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`expansion_module_${moduleIndex}_key_${val}_type`]}
            dataField={`expansion_module_${moduleIndex}_key_${val}_type`}
            title={`Expansion Module ${moduleIndex} Key ${val} Type`}
            selectOptions={[{ value: "0", label: "Disabled" },{ value: "16", label: "BLF" },{value:'5',label:'DND'},{value:'11',label:'DTMF'},{ value: "15", label: "Line" },{value:"13",label:"Speed Dial"},{value:"3",label:'Transfer'}]}
            type="select"
          />
          <VipProvisioningFieldMui
            updateField={updateField}
            data={line}
            dataField={`expansion_module_${moduleIndex}_key_${val}_line`}
            title={`Expansion Module ${moduleIndex} Key ${val} Line`}
            type="number"
          />
          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`expansion_module_${moduleIndex}_key_${val}_label`]}
            dataField={`expansion_module_${moduleIndex}_key_${val}_label`}
            title={`Expansion Module ${moduleIndex} Key ${val} Label`}
            type="string"
          />
          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`expansion_module_${moduleIndex}_key_${val}_value`]}
            dataField={`expansion_module_${moduleIndex}_key_${val}_value`}
            title={`Expansion Module ${moduleIndex} Key ${val} Value`}
            type="string"
          />
          <VipProvisioningFieldMui
            updateField={updateField}
            data={state[`expansion_module_${moduleIndex}_key_${val}_extension`]}
            dataField={`expansion_module_${moduleIndex}_key_${val}_extension`}
            title={`Expansion Module ${moduleIndex} Key ${val} Extension`}
            type="string"
          />
          <hr className="mb-3" />
        </div>
      })}
    </>} />
    })}

    {showYeaLinkFirmware && <ReviewCollapse header="Yealink Firmwares" initalOpen={false} content={<VipProvisioningYealinkFirmwares
        value={data.yealinkFirmwares}
        updateField={updateField}
      />} />}
    
    <ReviewCollapse header="Yealink Wallpapers" initalOpen={false} content={<VipProvisioningYealinkWallpapers expansionModuleWallpaper={state.yealinkExpansionModuleWallpaper} mainScreenWallpaper={state.yealinkMainWallpaper} updateField={updateField} />} />

    {updateFieldOverride === undefined && (
      <div style={{ textAlign: 'center' }}>
        {isSaving ? (<Loading />) : (<Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>)}
      </div>
    )}


  </>
}

export default memo(FormProvisioning, (a, b) => false)